module.exports = __webpack_public_path__ + "img/banner-b1.38803fbf.webp";